// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__h0oK6","title":"Header_title__2aslx","left":"Header_left__3dE4n","clinicName":"Header_clinicName__2TlLL"};